import { all_routes } from '../../../../feature-module/router/all_routes'

export const spvSidebarData = [
  {
    title: 'Users',
    icon: 'isax isax-profile-2user5',
    route: all_routes.adminUser,
  },
  {
    title: 'Transactions',
    icon: 'isax isax-shopping-cart5',
    route: all_routes.adminTransaction,
  },
  {
    title: 'CBT',
    icon: 'isax isax-clipboard-text5',
    route: all_routes.adminCBT,
  },
]
